import React from 'react';
import { Box } from '@mui/material';
import { useTranslate } from 'react-admin';
import { CustomButton } from '@/components/global/buttons/CustomButton';
import { useNavigate } from 'react-router-dom';
import CollapsibleSection from '@/components/global/fields/CollapsibleSection';
import GroupDevicesList from './GroupDevicesList.jsx';

const DeviceGroupDetailsCollapse = ({ isDevicesOpen, setIsDevicesOpen, record }) => {
    const navigate = useNavigate();
    const translate = useTranslate();

    const handleClick = e => {
        e.stopPropagation();
        const filter = encodeURIComponent(JSON.stringify({ groupId_in: [record.id] }));
        navigate(`/device?filter=${filter}`);
    };
    return (
        <Box className='details-sample-list device-details-collapse-wrapper' sx={{ position: 'relative' }}>
            <CollapsibleSection
                title={translate('resources.device.fields.devicesInGroup')}
                isOpen={isDevicesOpen}
                onToggle={() => setIsDevicesOpen(!isDevicesOpen)}
            >
                <Box className='device-details-collapse'>
                    <CustomButton
                        label={translate('resources.device.labels.showDevicesOnList')}
                        variant='contained'
                        color='secondary'
                        size='medium'
                        onClick={handleClick}
                        className='device-details-collapse-button'
                    />
                    <GroupDevicesList record={record} />
                </Box>
            </CollapsibleSection>
        </Box>
    );
};

export default DeviceGroupDetailsCollapse;
